/* eslint no-useless-escape: 0 */

const wh = "You\'re in between, precipice of dreams\n\nThe ocean yawns, shoreline surely dissolved\nNot sure what you saw on Neptune's widow's walk\n\nA gaping maw? The conclusion of it all?\nOr the perfect start?"

export default wh;